<template>
	<div class="container__menuuser">
		<MenuIconCard>
			<template #icon>
				<div class="container__menuuser__notification">
					<div
						:class="[
							'container__menuuser__notification__alert',
							temNotificacoes ? 'notification-enabled' : 'notification-disabled ',
						]"
					/>
					<i class="fas fa-bell" />
				</div>
			</template>
			<template #card>
				<MenuCardNotifications @mudarNotificacao="setarSeExisteNotificacaoNova" />
			</template>
		</MenuIconCard>

		<MenuIconCard>
			<template #icon>
				<div class="container__menuuser__profile">
					<img
						class="container__menuuser__profile__avatar"
						:src="fotoUrl"
						alt=""
						@error="onImageError"
					/>
					<p class="container__menuuser__profile__greeting">{{ getUserName() }}</p>
				</div>
			</template>
			<template #card>
				<MenuCardUser />
			</template>
		</MenuIconCard>
	</div>
</template>

<script>
import MenuCardNotifications from '../MenuCardNotifications/MenuCardNotifications'
import MenuCardUser from '../MenuCardUser/MenuCardUser'
import MenuIconCard from '../MenuIconCard/MenuIconCard'
import { refreshFotoUrl } from '../../../services/profilePhoto'

export default {
	components: { MenuIconCard, MenuCardNotifications, MenuCardUser },
	data: () => {
		return {
			temNotificacoes: false,
			temUsername: false,
			// reativo: inicia do localStorage e é renovado no mounted
			fotoUrlAtual: localStorage.getItem('fotoUrl') || '',
			// quando o SAS da fotoUrl expira (403), cai no avatar de iniciais
			imageFailed: false,
		}
	},
	computed: {
		fotoUrl() {
			if (!this.fotoUrlAtual || this.imageFailed) {
				return `https://ui-avatars.com/api/?name=${this.emailFormatado}&size=25`
			}
			return this.fotoUrlAtual
		},
		email() {
			return localStorage.getItem('username')
		},
		emailFormatado() {
			return this.email.split('@')[0]
		},
	},
	async mounted() {
		// renova o SAS da foto (o gravado no login expira em ~30min)
		const novaFotoUrl = await refreshFotoUrl()
		if (novaFotoUrl !== null) {
			this.fotoUrlAtual = novaFotoUrl
			this.imageFailed = false
		}
	},
	methods: {
		/**
		 * Método que troca o valor de (temNotificacoes)
		 */
		setarSeExisteNotificacaoNova(exitemNotificacoes) {
			this.temNotificacoes = exitemNotificacoes
		},

		onImageError() {
			this.imageFailed = true
		},

		getUserName() {
			const username = localStorage.getItem('username')
			if (!username || username === 'null') {
				return this.$t('hello') + ', ' + this.$t('visitor')
			}
			// mostra apenas o nome antes do @ (evita e-mail longo na navbar)
			return this.$t('hello') + ', ' + username.split('@')[0]
		},
	},
}
</script>

<style scoped>
.container__menuuser__notification {
	position: relative;
}

.container__menuuser__notification__alert {
	background-color: rgb(var(--color-default));
	border-radius: 50%;
	position: absolute;
	right: 0;
	top: -0.2rem;
	cursor: pointer;
	transform-origin: center;
	transition: all 0.1s linear;
}

.notification-disabled {
	height: 0px;
	width: 0px;
}

.notification-enabled {
	height: 10px;
	width: 10px;
}

.container__menuuser {
	height: 100%;
	display: flex;
	align-items: center;
}

.container__menuuser__profile {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 26px;
	height: 26px;
	cursor: pointer;
	margin-left: 0.5rem;
}

.container__menuuser__profile__avatar {
	height: 26px;
	width: 26px;
	border-radius: 50%;
	object-fit: cover;
}

/* nome posicionado abaixo do avatar sem aumentar a altura da linha */
.container__menuuser__profile__greeting {
	position: absolute;
	top: 100%;
	left: 50%;
	transform: translateX(-50%);
	margin-top: 2px;
	font-size: 0.6875rem;
	line-height: 1;
	color: rgb(var(--color-primary));
	white-space: nowrap;
}

.fas {
	font-size: 1.2rem;
	color: rgb(var(--color-primary));
	padding-left: 0.5rem;
	padding-right: 0.5rem;
	cursor: pointer;
}
</style>
